import { createClient } from '@supabase/supabase-js';
import type { SupabaseClient } from '@supabase/supabase-js';
import config from 'embroil/config/environment';

let supabase: SupabaseClient;

// In test environment (or when config is missing), provide a lightweight mock to avoid network/init errors
if (
  config.environment === 'test' ||
  !config.supabaseUrl ||
  !config.supabaseKey
) {
  const mockAuth = {
    async getSession() {
      return { data: { session: null }, error: null } as const;
    },
    onAuthStateChange(_cb: (event: string, session: unknown) => void): {
      data: { subscription: { unsubscribe: () => void } };
      error: null;
    } {
      return {
        data: { subscription: { unsubscribe() {} } },
        error: null,
      } as const;
    },
  } as unknown as SupabaseClient['auth'];

  supabase = {
    auth: mockAuth,
  } as unknown as SupabaseClient;
} else {
  supabase = createClient(config.supabaseUrl, config.supabaseKey, {
    auth: { flowType: 'pkce', storageKey: config.authStorageKey },
  });

  supabase.auth.onAuthStateChange((event) => {
    if (event === 'SIGNED_OUT') {
      window.location.href = config.baseUrl;
    }
  });
}

export default supabase;

declare module '@supabase/supabase-js' {
  interface Registry {
    supabase: SupabaseClient;
  }
}
